
// ---------------- Закладки ----------------
const $35da740d59af89ba$var$bookmarkInput = document.getElementById("bookmarkInput");
const $35da740d59af89ba$var$addBookmarkBtn = document.getElementById("addBookmarkBtn");
const $35da740d59af89ba$var$bookmarkList = document.getElementById("bookmarkList");
let $35da740d59af89ba$var$bookmarks = JSON.parse(localStorage.getItem("bookmarks")) || [];
function $35da740d59af89ba$var$saveBookmarks() {
    localStorage.setItem("bookmarks", JSON.stringify($35da740d59af89ba$var$bookmarks));
}
function $35da740d59af89ba$var$renderBookmarks() {
    $35da740d59af89ba$var$bookmarkList.innerHTML = "";
    $35da740d59af89ba$var$bookmarks.forEach((url, index)=>{
        const li = document.createElement("li");
        const link = document.createElement("a");
        link.href = url;
        link.textContent = url;
        link.target = "_blank";
        const deleteBtn = document.createElement("button");
        deleteBtn.textContent = "X";
        deleteBtn.classList.add("delete");
        deleteBtn.addEventListener("click", ()=>{
            $35da740d59af89ba$var$bookmarks.splice(index, 1);
            $35da740d59af89ba$var$saveBookmarks();
            $35da740d59af89ba$var$renderBookmarks();
        });
        link.addEventListener("dblclick", ()=>{
            const newUrl = prompt("\u041D\u043E\u0432\u0438\u0439 URL:", url);
            if (newUrl) {
                $35da740d59af89ba$var$bookmarks[index] = newUrl;
                $35da740d59af89ba$var$saveBookmarks();
                $35da740d59af89ba$var$renderBookmarks();
            }
        });
        li.append(link, deleteBtn);
        $35da740d59af89ba$var$bookmarkList.appendChild(li);
    });
}
$35da740d59af89ba$var$addBookmarkBtn.addEventListener("click", ()=>{
    const value = $35da740d59af89ba$var$bookmarkInput.value.trim();
    if (!value) return;
    $35da740d59af89ba$var$bookmarks.push(value);
    $35da740d59af89ba$var$saveBookmarks();
    $35da740d59af89ba$var$renderBookmarks();
    $35da740d59af89ba$var$bookmarkInput.value = "";
});
$35da740d59af89ba$var$renderBookmarks();
// ---------------- Форма ----------------
const $35da740d59af89ba$var$usernameInput = document.getElementById("username");
const $35da740d59af89ba$var$passwordInput = document.getElementById("password");
const $35da740d59af89ba$var$saveFormBtn = document.getElementById("saveBtn");
function $35da740d59af89ba$var$loadFormData() {
    const data = JSON.parse(localStorage.getItem("formData"));
    if (!data) return;
    $35da740d59af89ba$var$usernameInput.value = data.username || "";
    $35da740d59af89ba$var$passwordInput.value = data.password || "";
}
$35da740d59af89ba$var$saveFormBtn.addEventListener("click", ()=>{
    const formData = {
        username: $35da740d59af89ba$var$usernameInput.value,
        password: $35da740d59af89ba$var$passwordInput.value
    };
    localStorage.setItem("formData", JSON.stringify(formData));
});
$35da740d59af89ba$var$loadFormData();
// ---------------- Товари ----------------
const $35da740d59af89ba$var$products = [
    {
        name: "Laptop",
        price: 1200,
        description: "Powerful laptop"
    },
    {
        name: "Phone",
        price: 800,
        description: "Smartphone"
    },
    {
        name: "Headphones",
        price: 200,
        description: "Noise cancelling"
    }
];
const $35da740d59af89ba$var$productsContainer = document.getElementById("products");
const $35da740d59af89ba$var$searchInput = document.getElementById("search");
function $35da740d59af89ba$var$renderProducts(data) {
    $35da740d59af89ba$var$productsContainer.innerHTML = (0, {})({
        products: data
    });
}
$35da740d59af89ba$var$searchInput.addEventListener("input", (e)=>{
    const value = e.target.value.toLowerCase();
    const filteredProducts = $35da740d59af89ba$var$products.filter((product)=>product.name.toLowerCase().includes(value));
    $35da740d59af89ba$var$renderProducts(filteredProducts);
});
$35da740d59af89ba$var$renderProducts($35da740d59af89ba$var$products);


//# sourceMappingURL=hw8.lolo.d63aa62b.js.map
